module.exports = __webpack_public_path__ + "c7e5856a450bb224d80c217368cf8125.svg";